export const apiUrlMagikey = 'https://aws.magikey.com.br/api/v2'